import { useRef } from "react";
import { motion } from "framer-motion";
import { Quote, Star, ChevronLeft, ChevronRight } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "Maria S.",
    role: "Tutora da Bia",
    text: "Equipa muito profissional e atenciosa. Recomendo a quem ama os seus animais.",
  },
  {
    name: "João P.",
    role: "Tutor do Rex",
    text: "Atenderam o meu cão em urgência e foram fantásticos. Salvaram-lhe a vida.",
  },
  {
    name: "Ana R.",
    role: "Tutora do Tigre",
    text: "Sempre que precisei, estiveram lá. Obrigada por tanto cuidado.",
  },
];

export const Testimonials = () => {
  const scrollerRef = useRef(null);

  const scrollBy = (dir) => {
    if (!scrollerRef.current) return;
    const w = scrollerRef.current.clientWidth;
    scrollerRef.current.scrollBy({ left: dir * w * 0.8, behavior: "smooth" });
  };

  return (
    <section
      data-testid="testimonials-section"
      className="py-20 md:py-28 bg-[#FAF7F2]"
    >
      <div className="container-app">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <span className="inline-block text-xs font-bold uppercase tracking-[0.2em] text-[#88A096] mb-3">
              Testemunhos
            </span>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1A1A1A] tracking-tight">
              Histórias de quem já <span className="text-[#1E5F6E]">passou por cá</span>.
            </h2>
          </div>
          <div className="flex gap-2">
            <button
              onClick={() => scrollBy(-1)}
              data-testid="testimonial-prev"
              aria-label="Anterior"
              className="grid h-11 w-11 place-items-center rounded-full bg-white border border-[#1E5F6E]/15 text-[#1E5F6E] hover:bg-[#1E5F6E] hover:text-white transition-colors"
            >
              <ChevronLeft className="h-5 w-5" />
            </button>
            <button
              onClick={() => scrollBy(1)}
              data-testid="testimonial-next"
              aria-label="Seguinte"
              className="grid h-11 w-11 place-items-center rounded-full bg-white border border-[#1E5F6E]/15 text-[#1E5F6E] hover:bg-[#1E5F6E] hover:text-white transition-colors"
            >
              <ChevronRight className="h-5 w-5" />
            </button>
          </div>
        </div>

        <div
          ref={scrollerRef}
          data-testid="testimonial-carousel"
          className="flex overflow-x-auto gap-5 lg:gap-6 snap-x snap-mandatory pb-6 hide-scrollbar -mx-5 px-5 sm:-mx-8 sm:px-8"
        >
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              data-testid="testimonial-card"
              className="snap-center shrink-0 w-[88%] sm:w-[420px] md:w-[460px] rounded-3xl bg-white border border-[#1E5F6E]/8 p-8 md:p-9 shadow-soft hover:shadow-glow transition-shadow"
            >
              <Quote className="h-7 w-7 text-[#E8A87C]" />
              <blockquote className="mt-5 font-display text-xl md:text-[22px] font-semibold text-[#1A1A1A] leading-snug">
                “{t.text}”
              </blockquote>
              <div className="mt-7 flex items-center justify-between">
                <figcaption>
                  <div className="font-bold text-[#1A1A1A]">{t.name}</div>
                  <div className="text-xs text-[#5A5A5A] mt-0.5">{t.role}</div>
                </figcaption>
                <div className="flex gap-0.5">
                  {Array.from({ length: 5 }).map((_, k) => (
                    <Star
                      key={k}
                      className="h-4 w-4 fill-[#E8A87C] text-[#E8A87C]"
                    />
                  ))}
                </div>
              </div>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
